var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4488_5131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.75 20.2279C29.75 18.6653 28.4792 17.3945 26.9167 17.3945H24.0833C22.5208 17.3945 21.25 18.6653 21.25 20.2279C18.9068 20.2279 17 22.1347 17 24.4779V30.1445C17 32.4877 18.9068 34.3945 21.25 34.3945H29.75C32.0932 34.3945 34 32.4877 34 30.1445V24.4779C34 22.1347 32.0932 20.2279 29.75 20.2279ZM24.0833 18.8112H26.9167C27.6972 18.8112 28.3333 19.4473 28.3333 20.2279H22.6667C22.6667 19.4473 23.3027 18.8112 24.0833 18.8112ZM32.5833 30.1445C32.5833 31.7071 31.3126 32.9779 29.75 32.9779H21.25C19.6874 32.9779 18.4167 31.7071 18.4167 30.1445V27.3112H24.7917V29.4362C24.7917 29.8272 25.109 30.1445 25.5 30.1445C25.891 30.1445 26.2083 29.8272 26.2083 29.4362V27.3112H32.5833V30.1445ZM32.5833 25.8945H18.4167V24.4779C18.4167 22.9153 19.6874 21.6445 21.25 21.6445H29.75C31.3126 21.6445 32.5833 22.9153 32.5833 24.4779V25.8945ZM12.75 17.3945C17.4377 17.3945 21.25 13.5823 21.25 8.89453C21.25 4.20678 17.4377 0.394531 12.75 0.394531C8.06225 0.394531 4.25 4.20678 4.25 8.89453C4.25 13.5823 8.06225 17.3945 12.75 17.3945ZM12.75 1.8112C16.6558 1.8112 19.8333 4.98878 19.8333 8.89453C19.8333 12.8003 16.6558 15.9779 12.75 15.9779C8.84425 15.9779 5.66667 12.8003 5.66667 8.89453C5.66667 4.98878 8.84425 1.8112 12.75 1.8112ZM15.5762 21.1629C15.521 21.5496 15.1697 21.823 14.7744 21.7635C14.2247 21.6842 13.6637 21.6445 13.1042 21.6445C6.65975 21.6445 1.41667 26.8876 1.41667 33.332V33.6862C1.41667 34.0772 1.09933 34.3945 0.708333 34.3945C0.317333 34.3945 0 34.0772 0 33.6862V33.332C0 26.1056 5.87775 20.2279 13.1042 20.2279C13.7303 20.2279 14.3608 20.2732 14.9756 20.361C15.3623 20.4177 15.6315 20.7761 15.5762 21.1629Z",
    fill: "url(#paint0_linear_4488_5131)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4488_5131",
    x1: -4.95833,
    y1: -7.39714,
    x2: 30.4583,
    y2: 34.3945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7410FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4488_5131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0 0.394531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeMan);
export default __webpack_public_path__ + "static/media/employee-man.08417f15e7917d86b01456b4f2616a48.svg";
export { ForwardRef as ReactComponent };